import React from 'react';
import {
  Responsive,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  BooleanInput,
  List,
  SimpleList,
  Datagrid,
  EditButton,
  ShowButton,
  Edit,
  Show,
  SimpleShowLayout,
  SelectInput,
  DisabledInput,
  downloadCSV,
  Filter
} from 'react-admin';
import { listUnidad } from '../utils'
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

export const UnidadCustom = ({ source, record = {} }) => {
  var found = listUnidad.find(function(element) {
    return element.unidad === record.unidad;
  });
  var foundNombre = (found === undefined ? '' : found.name);
  return foundNombre;
}

export const DisabledInputCustom = ({ source, record = {} }) => {
  var foundNombre = UnidadCustom({source, record });
  return (<DisabledInput source={ "Unidad: " + foundNombre }/>)
}

const MaterialEditTitle = ({ source, record }) => {

  var unidad = UnidadCustom({source, record});
  return (
    <Responsive
      small={
        <span>
          Editar Material
        </span>
      }
      medium={
        <span>
          Editar Material: {
            record ? `"${record.nombre}" - Unidad: ${unidad}` : ""
          }
        </span>
      }
    />
  );
};

const MaterialShowTitle = ({ source, record }) => {
  return <span>Material: {record ? `${record.nombre.toUpperCase()}` : ""}</span>;
};

const Content = ({ record }) => {
  return (
    <div>
      { record &&
        <div>
          <span>nombre: {record.nombre} </span><br />
          <span>precio: {record.precio} </span><br />
          <span>peso: {record.pesoXUnidad} </span>
        </div>
      }
    </div>
  );
};

export const MaterialShow = props => (
  <Show title={<MaterialShowTitle />} {...props}>
    <SimpleShowLayout>
      <Content />
    </SimpleShowLayout>
  </Show>
);

export const MaterialCreate = props => (
  <Create {...props} title="Cargar Nuevo Material">
    <SimpleForm redirect="/materiales">
      <TextInput label="Nombre del Material" source="nombre" autoFocus/>
      <TextInput label="Precio" type="number" source="precio" />
      <TextInput label="Peso estimado" type="number" source="pesoXUnidad" />
      <SelectInput source="unidad" optionValue="unidad" choices={listUnidad} />
      <BooleanInput label="Visible en pesajes" source="enPesajes" />
    </SimpleForm>
  </Create>
);

export const MaterialFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
    </Filter>
  )
}

export const MaterialList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<MaterialFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          secundaryText={record => `Precio: ${record.precio}`}
        />
      }
      medium={
        <Datagrid>
          <TextField label="Nombre" source="nombre" />
          <TextField label="Precio" source="precio" />
          <TextField label="Peso estimado" type="number" source="pesoXUnidad" />
        </Datagrid>
      }
    />
  </List>
);

const exporter = data => {
    const csv = convertToCSV({
        data,
        fields: ['nombre', 'precioCosto', 'unidad' ],
    });
    downloadCSV(csv, 'ingreso-puerta-puerta'); // download as 'posts.csv` file
};

export const MaterialEditableList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<MaterialFilter />}
    exporter={exporter}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
          secondaryText={record =>
            `Precio: ${record.precio}`
          }
        />
      }
      medium={
        <Datagrid>
          <TextField label="Nombre" style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField label="Precio" source="precio" />
          <TextField label="Peso estimado" source="pesoXUnidad"/>
          <UnidadCustom label="Unidad"/>
          <EditButton />
          <ShowButton />
        </Datagrid>
      }
    />
  </List>
);

export const MaterialEdit = (props) => {
  return (
  <Edit title={<MaterialEditTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Nombre del Material" source="nombre" autoFocus/>
      <TextInput label="Precio" type="number" source="precio" />
      <TextInput label="Peso por unidad" type="number" source="pesoXUnidad" />
      <SelectInput source="unidad" optionValue="unidad" choices={listUnidad} />
      <BooleanInput label="Visible en pesajes" source="enPesajes" />
    </SimpleForm>
  </Edit>
  );
}



// WEBPACK FOOTER //
// ./src/services/materiales.js